import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from './plugins/axios'
import customFilters from './utils/customVueFilters'
import VueMask from 'v-mask'

Vue.filter('currency', customFilters.currency)
Vue.config.productionTip = false

Vue.use(VueMask)

new Vue({
  router,
  store,
  vuetify,
  axios,
  render: h => h(App)
}).$mount('#app')
